const ENDPOINTS = {
  TRACKING_ANTENNA_HOST: '{{ENV_TRACKING_ANTENNA_HOST}}',
  PP_SHARED_ASSETS: 'https://assets.parcelperform.com/pp-web-app-assets',
};

export default ENDPOINTS;
